<template>
  <div
    class="flex items-center gap-1.5 font-semibold leading-none rounded-xl py-1 !px-2"
    :class="[fontSize, containerClass]"
  >
    <div class="pr-1.5 border-r flex" :class="dividerClass" v-if="resolvedShowPrivacyBadge">
      <album-privacy-badge
        :album="container"
        icon-only
      />
    </div>
    <core-tooltip :text="`${container.files_count} file(s)`">
      <div class="flex items-center gap-0.5">
        <u-icon name="i-ri-image-2-line" />
        <span class="leading-none mt-px" :class="fontSize">{{container.files_count}}</span>
      </div>
    </core-tooltip>
    <core-tooltip v-if="container.albums_count !== undefined" :text="`${container.albums_count} nested album(s)`">
      <div class="flex items-center gap-0.5">
        <u-icon :name="COMMON_ICONS.nestedAlbum" />
        <span class="leading-none mt-px" :class="fontSize">{{container.albums_count}}</span>
      </div>
    </core-tooltip>
  </div>
</template>

<script setup>
  const props = defineProps({
    container: Object,
    size: {
      type: String,
      default: 'sm'
    },
    dark: Boolean,
    showPrivacyBadge: {
      type: Boolean,
      default: undefined
    },
    centered: {
      type: Boolean,
      default: true
    }
  });

  const {currentUserId} = useSessionStore();
  const defaultShowPrivacyBadge = computed(() => {
    const isOwner = props.container.user_id === currentUserId;
    const isSharedItem = props.container.sharedItemId;
    return props.container.isAlbum && !props.container.isNested && (isOwner || isSharedItem);
  });

  const resolvedShowPrivacyBadge = computed(() => {
    return props.showPrivacyBadge ?? defaultShowPrivacyBadge.value;
  });

  const fontSize = computed(() => {
    switch (props.size) {
      case 'sm': return 'text-sm';
      case 'md': return 'text-base';
    }
  });

  const containerClass = computed(() => {
    const alignmentClass = props.centered ? 'justify-center' : 'justify-start';

    if (props.dark) {
      return `${alignmentClass} text-gray-200 bg-black/75 border border-transparent`;
    }

    return `${alignmentClass} text-charcoal bg-white border border-charcoal-200`;
  });

  const dividerClass = computed(() => props.dark ? 'border-gray-500' : 'border-charcoal/20');

</script>
